import React from "react";
import { Box, Container, Typography, Link, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  const scrollToSection = (href) => {
    if (href.startsWith("#")) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "white",
        color: "black",
        borderTop: "1px solid #e0e0e0",
        py: { xs: 8, md: 14 },
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1400px",
          pl: { xs: 2, md: 14 },
          pr: 2,
          mx: "auto",
        }}
      >
        {/* Dreispaltige Aufteilung */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
            gap: 4,
            alignItems: "start",
            minHeight: "120px",
          }}
        >
          {/* Linke Spalte: Navigation Links */}
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Link
              component={RouterLink}
              to="/impressum"
              sx={{
                color: "black",
                textDecoration: "none",
                fontSize: "1rem",
                "&:hover": {
                  textDecoration: "underline",
                  color: "#3a7b3e",
                },
              }}
            >
              Impressum
            </Link>
            <Link
              component={RouterLink}
              to="/datenschutz"
              sx={{
                color: "black",
                textDecoration: "none",
                fontSize: "1rem",
                "&:hover": {
                  textDecoration: "underline",
                  color: "#3a7b3e",
                },
              }}
            >
              Datenschutz
            </Link>
            <Link
              href="https://corpshaus2.de/"
              sx={{
                color: "black",
                textDecoration: "none",
                fontSize: "1rem",
                "&:hover": {
                  textDecoration: "underline",
                  color: "#3a7b3e",
                },
              }}
            >
              Intern
            </Link>
          </Box>

          {/* Mittlere Spalte: Logo */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src="/logo_01.svg"
              alt="Corps Guestphalia Berlin"
              sx={{
                height: 140,
                width: "auto",
                flexGrow: 1,
                cursor: "pointer",
                maxWidth: "200px",
              }}
              onClick={() => scrollToSection("#home")}
            />
          </Box>

          {/* Rechte Spalte: Kontaktinformationen */}
          <Box sx={{ textAlign: { xs: "center", md: "right" } }}>
            <Typography
              variant="body2"
              sx={{
                color: "black",
                lineHeight: 1.5,
                fontSize: "1rem",
              }}
            >
              Corps Guestphalia Berlin
              <br />
              Schwendenerstrasse 13
              <br />
              14195 Berlin-Dahlem
              <br />
              <br />
              Tel.: 030 - 83 227 866
              <br />
              adh@guestphalia-berlin.de
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
